// extracted by mini-css-extract-plugin
export default {"container":"iS-z","timeTop":"jS-z","timeCountdown":"kS-z","cta":"lS-z","disabled":"mS-z","product":"nS-z"};